import { Component, Input } from '@angular/core';

@Component({
  selector: 'vb-static-text',
  imports: [],
  templateUrl: './static-text.component.html',
  styleUrl: './static-text.component.scss'
})
export class StaticTextComponent {
  @Input() textHeader: string = '';
  @Input() textContent: string = '';
}
